import { createFileRoute } from "@tanstack/react-router";
import LiveRoom from "@/pages/LiveRoom";
import { MainLayout } from "@/components/layout/MainLayout";
import { readableFixture, socialMeta } from "@/lib/routeSocial";

export const Route = createFileRoute("/live/$slug")({
  head: ({ params }) => {
    const { name } = readableFixture(params.slug);
    return {
      meta: socialMeta({
        seo: { topics: ["live"] },
        title: `${name} — Live Match Intelligence | Statlign`,
        description: `Live score, model pick, confidence and expected-value read for ${name}.`,
      }),
    };
  },
  component: () => (
    <MainLayout>
      <LiveRoom />
    </MainLayout>
  ),
});
